import { Box, Drawer as MuiDrawer, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const DRAWER_WIDTH = 576

export const StyledDrawer = styled(MuiDrawer)`
  .MuiPaper-root {
    background: ${theme.colors.surfaceContainerBackground};
    box-shadow: ${theme.attributes.boxShadow.selectFieldPaper};
    width: ${DRAWER_WIDTH}px;
    overflow-x: hidden;

    ::-webkit-scrollbar {
      width: 4px;
      background: transparent;
    }

    ::-webkit-scrollbar-track {
      box-shadow: none;
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.borderMedium};
      border-radius: ${theme.attributes.borderRadius.quaternary};
    }
  }
`

export const DrawerContent = styled(Box)`
  height: 100%;
  padding: ${theme.spacing.xLarge}px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const DrawerHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${theme.spacing.small}px;
`

export const DrawerTitle = styled(Typography)`
  font-size: ${theme.typography.fontSize.xxxxLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
`

export const DrawerDescription = styled(Typography)`
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  color: ${theme.colors.devicesSecondaryText};
  line-height: 20px;
  margin-bottom: ${theme.spacing.medium}px;
`

export const SectionHeading = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 24px;
  letter-spacing: 0.1px;
  color: ${theme.colors.menuItemText};
  margin-bottom: ${theme.spacing.small}px;
`

export const InfoRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm}px;
  margin-bottom: ${theme.spacing.small}px;
`

export const InfoIconWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: ${theme.attributes.borderRadius.secondary};
  background: ${theme.colors.devicesRowHoverBg};
  color: ${theme.colors.dropdownLabel};

  svg {
    stroke: ${theme.colors.dropdownLabel};
  }

  html[data-theme='light'] & {
    color: ${theme.colors.caption};

    /* Some icons bake the dark stroke on their paths; the inherited svg stroke can't reach those. */
    svg,
    svg path {
      stroke: ${theme.colors.caption};
    }
  }
`

export const InfoLabel = styled(Typography)`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.normal};
  color: ${theme.colors.devicesSecondaryText};
  line-height: 22px;
`

export const InfoValue = styled(Typography)`
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
  line-height: 20px;
`

export const SectionDivider = styled(Box)`
  margin: ${theme.spacing.small}px 0;
`
